import { createContext, useContext } from "react";

/**
 * Opt-in skin for the shared form primitives and the controls beside them.
 *
 * `"styleguide"` is the default for every screen that doesn't opt in. The
 * customer app provides `"enroll"` once at its root (main.tsx), and the member
 * login screen wraps itself in it. The primitives read the skin via
 * `useFormSkin()` and swap only the class fragments that differ between skins.
 */
export type FormSkin = "styleguide" | "enroll";

export const FormSkinContext = createContext<FormSkin>("styleguide");

/** The active form-primitive skin for the current subtree. */
export function useFormSkin(): FormSkin {
  return useContext(FormSkinContext);
}
